import PropTypes from 'prop-types';
import { useCallback } from 'react';

function JsonDownload({ schema, dataElementId, version }) {
	const handleDownload = useCallback(() => {
		const json = JSON.stringify(schema, null, 2);
		const blob = new Blob([json], { type: 'application/json' });
		const url = URL.createObjectURL(blob);
		const anchor = document.createElement('a');
		anchor.href = url;
		anchor.download = `${dataElementId}-${version}.json`;
		document.body.appendChild(anchor);
		anchor.click();
		document.body.removeChild(anchor);
		URL.revokeObjectURL(url);
	}, [schema, dataElementId, version]);

	return (
		<button
			type="button"
			className="dsv-btn dsv-btn--ghost"
			onClick={handleDownload}
			title="Download schema as JSON file"
			data-testid="json-download-btn"
		>
			Download JSON
		</button>
	);
}

JsonDownload.propTypes = {
	schema: PropTypes.any,
	dataElementId: PropTypes.string,
	version: PropTypes.string,
};

export default JsonDownload;
